import api from './api';

export const getAppointments = (params) =>
  api.get('/api/v1/appointments', { params }).then((r) => r.data.data);

export const getAppointment = (id) =>
  api.get(`/api/v1/appointments/${id}`).then((r) => r.data.data);

export const createAppointment = (data) =>
  api.post('/api/v1/appointments', data).then((r) => r.data.data);

export const updateAppointment = (id, data) =>
  api.put(`/api/v1/appointments/${id}`, data).then((r) => r.data.data);

export const deleteAppointment = (id) =>
  api.delete(`/api/v1/appointments/${id}`).then((r) => r.data);

export const cancelRecurringAppointments = (id, reason) =>
  api.delete(`/api/v1/appointments/${id}/recurring`, { data: { reason } }).then((r) => r.data);

export const getAppointmentTypes = () =>
  api.get('/api/v1/appointment-types').then((r) => r.data.data);

export const joinTelehealthRoom = (id) =>
  api.get(`/api/v1/appointments/${id}/join`).then((r) => r.data.data);

export const getPractitioners = () =>
  api.get('/api/v1/practitioners').then((r) => r.data.data.practitioners);

export const updateGroupClientStatus = (appointmentId, clientId, status) =>
  api.put(`/api/v1/appointments/${appointmentId}/clients/${clientId}`, { status }).then((r) => r.data);

export const generateGroupInvoices = (appointmentId, data = {}) =>
  api.post(`/api/v1/appointments/${appointmentId}/group-invoices`, data).then((r) => r.data);

export const approveAppointment = (id) =>
  api.post(`/api/v1/appointments/${id}/approve`).then((r) => r.data);

export const declineAppointment = (id, reason) =>
  api.post(`/api/v1/appointments/${id}/decline`, { reason }).then((r) => r.data);
